import React from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { GradeInMonth } from './GradeInMonth'

const StudentGradeInMonth = () => {
	const { studentId } = useParams()
	const { user } = useAuth()

	// Detect if this is being viewed by instructor or student
	const isInstructorView = user?.role === 'Instructor'

	// Use studentId from params if instructor, otherwise use logged-in user's id
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	return (
		<StudentTopMenuLayout activeMenu="GradeList" pageName="CurrentGrades">
			<GradeInMonth studentId={effectiveStudentId} classId={isInstructorView ? null : user?.class} isStudent={!isInstructorView} />
		</StudentTopMenuLayout>
	)
}

export { StudentGradeInMonth }
